import type ViewType from '../store/schema/ViewType';

/**
 *
 * @param messageListExpansionType Checks whether the reading pane view type is supported given the message list expansion type
 * @param readingPaneViewType
 * @returns
 */
export default function isMessageOrganizationMatrixSupported(
    messageListExpansionType: ViewType,
    readingPaneViewType: ViewType
): boolean {
    return messageListExpansionType <= readingPaneViewType && readingPaneViewType !== 1;
}
